var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h1',[_vm._v("Contact")]),_c('div',[_vm._v("Have a question or concern? Is the site not working correctly, or do you have a suggestion for improvement? Contact us!")]),_c('div'),_c('div',[_c('a',{attrs:{"href":"mailto:info@sharemyscrapbook.com"}},[_vm._v("info@sharemyscrapbook.com")])])])
}]

export { render, staticRenderFns }